import { render, staticRenderFns } from "./NewClientForm.vue?vue&type=template&id=83468d48"
import script from "./NewClientForm.vue?vue&type=script&lang=js"
export * from "./NewClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports